import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "MoveFolder" */ "./lazyIndex"), { name: "MoveFolder" });

export const lazyMoveFolder: LazyAction<typeof lazyIndex.moveFolder, typeof lazyModule> = new LazyAction(lazyModule, m => m.moveFolder);
